export default function LoaderPost() {
  return (
    <div className="flex items-center space-x-2 my-4 gap-4">
      <div className="animate-pulse bg-gray-300 h-12 w-12 rounded-full"></div>{" "}
      <div className="space-y-2">
        <div className="animate-pulse rounded-md bg-gray-300 h-4 w-[200px]"></div>{" "}
        <div className="animate-pulse rounded-md bg-gray-300 h-4 w-[170px]"></div>{" "}
      </div>
    </div>
  );
}
